import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { EntityConfigService } from "../../services/entity-config-service";
import { ReportService } from "../../services/report-service";
import { NotifyService } from "../../services/notify-service";
import { StorageService } from "../../services/storage-service";

export class DataExportController {
    static $inject = ["$scope", "$location", "$window", "$q", "$log", "entityConfigService", "reportService", "notifyService", "storage"];
    initialized: boolean;   // flag	for	if controller was initialized
    selectedCharTypeId: number;	// current selected	char type
    selectedTemplateId: number;// current selected	template
    selectedRelatedCharTypeId: number;		// current selected char type of the related entity
    selectedRelatedTemplateId: number;// current selected	template of the related entity
    itemRows: Models.IEntitySearchDoc[];			// search result item rows
    page: number;				// current page
    pageCount: number;			// current page	count of search	results
    qTime: number;				// time	in ms of search	operation
    jumpTo: number;				// jump-to input value
    charTypes: Models.ICharacteristicType[];//char type data for select box
    relatedCharTypes: Models.ICharacteristicType[];          //char type data for select box of the related entity        
    templates: Models.ICharacteristicTemplate[];			// template	data for select	box                
    relatedTemplates: Models.ICharacteristicTemplate[];			// template	data for select	box of the related entity
    selectedChar: Models.ICharacteristic; 			// char	data for multip select box
    selectedRelatedChar: Models.ICharacteristic;
    sortField: string;
    sortDir: number;
    numFound: number;
    //reportingChars: { [charTypeID: number]: any };
    reportingChars: Models.IDynamicReportColumnChar[];
    savedQueryReports: Models.ISavedQueryReport[];
    selectedReport: Models.ISavedQueryReport;
    savedReportNames: string[];
    reportName: string;
    allColumnChars: { [charTypeID: number]: any };
    allColumnFilteredChars: { [charTypeID: number]: any };
    allRelatedChars: { [charTypeID: number]: any };
    allRelatedFilteredChars: { [charTypeID: number]: any };
    showRelated: boolean;
    selectedRelatedTemplatePartyId: number;
    selectedRelatedTemplateParties: Models.IParty[];
    savedDataExportReportKey: string;
    rowCount: number;
    removedAllColumnCharFromReportingChars: boolean;
    allColumnCharsUpdated: boolean;
    allColumnRelatedCharsUpdated: boolean;

    constructor(private $scope: ng.IScope,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $log: ng.ILogService,
        private entityConfigService: EntityConfigService,
        private reportService: ReportService,
        private notifyService: NotifyService,
        private storage: StorageService) {

        this.selectedCharTypeId = 0;
        this.selectedTemplateId = 0;
        this.selectedRelatedCharTypeId = 0;
        this.selectedRelatedTemplateId = 0;
        this.entityConfigService = entityConfigService;
        this.charTypes = [];
        this.relatedCharTypes = [];
        this.templates = [];
        this.relatedTemplates = [];
        this.selectedChar = null;
        this.selectedRelatedChar = null;
        this.page = 1;
        this.jumpTo = 1;
        this.pageCount = 1;
        this.sortDir = 0;
        this.sortField = "";
        //this.reportingChars = {};
        this.reportingChars = [];
        this.savedQueryReports = [];
        this.savedReportNames = [];
        this.reportName = "";
        this.selectedReport = null;
        this.allColumnChars = {};
        this.allColumnFilteredChars = {};
        this.allRelatedChars = {};
        this.allRelatedFilteredChars = {};
        this.showRelated = false;
        this.selectedRelatedTemplatePartyId = 0;
        this.selectedRelatedTemplateParties = [];
        this.savedDataExportReportKey = "dynamicExport_" + Consts.userDivAppUrlHash;
        this.rowCount = 25;
        this.itemRows = [];
        this.removedAllColumnCharFromReportingChars = false;
        this.allColumnCharsUpdated = false;
        this.allColumnRelatedCharsUpdated = false;

        //add watches to anything that nees to fire ExecuteReport
        $scope.$watch(() => this.selectedCharTypeId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                // this.$log.info("CharTypeChanged called");
                this.CharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedRelatedCharTypeId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.RelatedCharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedTemplateId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                // this.$log.info("TemplateChanged called");
                this.TemplateChanged();
            }
        });

        $scope.$watch(() => this.selectedRelatedTemplateId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.RelatedTemplateChanged();
            }
        });

        $scope.$watch(() => this.sortField,
            (newValue: string, oldValue: string) => {
                if (newValue != oldValue) {
                    this.ExecuteReport();
                }
            }, true);

        $scope.$watch(() => this.rowCount, (newValue: number, oldValue: number) => {
            if (newValue != oldValue) {

                this.ExecuteReport();

            }
        });

        $scope.$watch(() => [this.page, this.sortDir],
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.ExecuteReport();
                }
            }, true);

        //$scope.$watch(() => this.reportingChars, (newValue, oldValue) => {
        //    if (newValue != oldValue && newValue != null) {
        //        var count = 0;
        //        for (var key in newValue) {
        //            count++;
        //        }

        //        if (count > 0) {
        //            // this.$log.info("ExecuteReport called");
        //            this.ExecuteReport();
        //        }
        //    }
        //}, true);

        $scope.$watch(() => this.reportingChars, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                if (newValue.length > 0) {
                    // this.$log.info("ExecuteReport called");
                    this.ExecuteReport();
                }
            }
        }, true);

        $scope.$watch(() => this.selectedChar, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                //this.$log.info("UpdateCharacteristicsMultiSelectList called");                    
                this.AddCharacteristicToReport(newValue);
            }
        }, true);

        $scope.$watch(() => this.selectedRelatedChar, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                //this.$log.info("UpdateCharacteristicsMultiSelectList To Add RelatedChar called");                    
                this.AddRelatedCharacteristicToReport(newValue);
            }
        }, true);

        $scope.$watch(() => this.selectedReport, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                // this.$log.info("selectedReport Watch");
                this.LoadReport();
            }
        }, true);

        //$scope.$watch(() => [this.allColumnChars, this.reportingChars], (newValue, oldValue) => {
        //    if (newValue != oldValue) {
        //        //Filter column Tab chars
        //        //this.$log.info("Filtering all columns tab characteristics");
        //        if (this.allColumnCharsUpdated) {
        //            var allColumnChars = newValue[0];
        //            var reportingChars = newValue[1];

        //            for (var char in allColumnChars) {        
        //                if (_.any(this.reportingChars, rc => rc.characteristicID == char)){
        //                    delete this.allColumnFilteredChars[char];
        //                }
        //                else {
        //                    this.allColumnFilteredChars[char] = allColumnChars[char];
        //                }                            
        //            }
        //        }
        //    }
        //}, true);

        //$scope.$watch(() => [this.allRelatedChars, this.reportingChars], (newValue, oldValue) => {
        //    if (newValue != oldValue) {
        //        if (this.allColumnRelatedCharsUpdated) {
        //            var allRelatedChars = newValue[0];
        //            var reportingChars = newValue[1];

        //            for (var char in allRelatedChars) {
        //                if (_.any(this.reportingChars, rc => rc.characteristicID == char)) {
        //                    delete this.allRelatedFilteredChars[char];
        //                }
        //                else {
        //                    this.allRelatedFilteredChars[char] = allRelatedChars[char];
        //                }
        //            }
        //        }

        //    }
        //}, true);
    }

    ResetAll() {
        this.selectedCharTypeId = 0;
        this.selectedTemplateId = 0;
        this.selectedReport = null;
        this.relatedCharTypes = [];
        this.selectedRelatedCharTypeId = 0;
        this.relatedTemplates = [];
        this.selectedRelatedTemplateId = 0;
        this.selectedRelatedTemplateParties = [];
        this.selectedRelatedTemplatePartyId = 0;
        this.allRelatedFilteredChars = [];
        this.ResetColumns();
    }

    ResetColumns() {
        this.reportingChars = [];
        this.showRelated = false;
        this.page = 1;
        this.jumpTo = 1;
        this.pageCount = 1;
        this.sortDir = 0;
        this.sortField = "";
        this.selectedChar = null;
        this.itemRows = [];
    }

    GetExportUrl() {
        var query: string[];
        query = [];

        _.forEach(this.reportingChars, rc => {
            query.push(rc.tagName);
        });

        //for (var rc in this.reportingChars) {
        //    var r = this.reportingChars[rc];
        //    query.push(r.tagName);
        //}

        var url = "/api/report/exportreport";
        url = url + "?cols=" + query.join(',');
        url = url + '&charTypeID=' + this.selectedCharTypeId;
        url = url + '&templateID=' + this.selectedTemplateId;

        return url;
    }

    ExportReport() {
        var query: string[];
        query = [];

        _.forEach(this.reportingChars, rc => {
            query.push(rc.tagName);
        });

        //for (var rc in this.reportingChars) {
        //    query.push(this.reportingChars[rc].tagName);
        //}
        //this.$log.info("ExecuteReport_1 called");
        var reportRequest: Models.IDynamicReportRequest = {
            ct: this.selectedCharTypeId,    // slected char type
            t: this.selectedTemplateId,	    // selected	template
            cols: query,                    // selected characteristics   
            relIndId: this.selectedRelatedTemplatePartyId,
            p: this.page - 1,			    // the current page
            r: 10,						    // rows to return
            sf: this.sortField,			    // sort Field
            sd: this.sortDir			    // sort direction 0 - ascending, 1 - descending
        };

        if (this.selectedCharTypeId != 0 && this.selectedTemplateId != 0 && this.reportingChars != []) {
            // call	service to get the report results exported to excell file and email file to user for download
            this.notifyService.startProgress(); // start progress bar
            this.reportService.exportReport(reportRequest)
                .then((result) => {
                    alert("An email with a link to download this export has been sent to your email address.");
                })
                .catch((reason: any) => {
                    alert("busted");
                })
                .finally(() => {
                    this.initialized = true;
                    this.notifyService.endProgress();
                });
        }
    }

    Init() {
        this.entityConfigService.getCharacteristicTypes()
            .then((result) => {
                //this.$log.info("Init called");
                this.charTypes = result;
                this.GetSavedReportParams();
            });
    }

    // calls a search using	current	state data
    ExecuteReport() {
        var query: string[];
        query = [];

        _.forEach(this.reportingChars, rc => {
            query.push(rc.tagName);
        });

        //for (var rc in this.reportingChars) {
        //    query.push(this.reportingChars[rc].tagName);
        //}
        //this.$log.info("ExecuteReport_1 called");
        var reportRequest: Models.IDynamicReportRequest = {
            ct: this.selectedCharTypeId,    // slected char type
            t: this.selectedTemplateId,	    // selected	template
            cols: query,                    // selected characteristics    
            relIndId: this.selectedRelatedTemplatePartyId, // Selected TemplatePartyId            
            p: this.page - 1,			    // the current page
            r: this.rowCount,						    // rows to return
            sf: this.sortField,			    // sort Field
            sd: this.sortDir			    // sort direction 0 - ascending, 1 - descending
        };

        if (this.selectedCharTypeId != 0 && this.selectedTemplateId != 0 && this.reportingChars != []) {
            // call	service to get the report results
            this.notifyService.startProgress(); // start progress bar
            this.reportService.dynamicReport(reportRequest)
                .then((result) => {
                    this.itemRows = result.resultDocs;
                    this.qTime = result.qTime;
                    this.numFound = result.numFound;
                    this.pageCount = result.pageCount;
                    this.jumpTo = this.page;
                    this.showRelated = true;
                })
                .catch((reason: any) => {
                    alert("busted");
                })
                .finally(() => {
                    this.initialized = true;
                    this.notifyService.endProgress();
                });
        }
    }

    CharTypeChanged() {
        // this.$log.info("CharTypeChanged_1 called");
        if (this.selectedCharTypeId > 0) {
            this.page = 1;				// reset page
            this.selectedTemplateId = 0;   // reset selected template
            this.selectedChar = null; //clear selected chars
            this.relatedCharTypes = []; //clear related char types
            this.reportingChars = [];
            this.reportingChars = [];
            this.selectedRelatedCharTypeId = 0;
            this.relatedTemplates = [];
            this.selectedRelatedTemplateId = 0;
            this.selectedRelatedTemplateParties = [];
            this.selectedRelatedTemplatePartyId = 0;
            this.allRelatedFilteredChars = [];
            this.showRelated = false;
            this.itemRows = [];
            this.notifyService.startProgress();
            return this.entityConfigService.getCharacteristicTemplates(this.selectedCharTypeId).then((result) => {
                this.templates = result;
                this.notifyService.endProgress();
            });
        }
        else {
            this.Init();
        }

    }

    RelatedCharTypeChanged() {
        this.page = 1;				// reset page
        this.selectedRelatedTemplateId = 0;   // reset selected template            
        this.allRelatedChars = {};
        this.allRelatedFilteredChars = {};
        this.relatedTemplates = [];
        this.notifyService.startProgress();

        if (this.selectedRelatedCharTypeId > 0) {
            var promise1 = this.entityConfigService.getCharacteristicTemplates(this.selectedRelatedCharTypeId).then((result) => {
                this.relatedTemplates = result;
                this.notifyService.endProgress();
            });

            return this.$q.all([promise1]);
        }
    }

    // fired whenever template is changed
    TemplateChanged() {
        //this.$log.info("TemplateChanged_1 called");
        this.page = 1;				// reset page
        this.selectedChar = null; //clear selected chars
        this.allColumnChars = {};
        this.allColumnFilteredChars = {};
        this.reportingChars = [];
        this.allColumnCharsUpdated = true;
        this.allColumnRelatedCharsUpdated = false;
        //get the characteristics for selected CharType and Template
        if (this.selectedCharTypeId > 0 && this.selectedTemplateId > 0) {
            var promise1 = this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.selectedCharTypeId, this.selectedTemplateId).then((result) => {
                for (var i = 0; i < result.length; i++) {
                    var ct = result[i];
                    this.allColumnChars[ct.characteristicID] = { tagName: ct.tagLabel, label: ct.label };
                    this.allColumnFilteredChars[ct.characteristicID] = { tagName: ct.tagLabel, label: ct.label };
                }
            });
            //get the related char types for the selected type and template
            var promise2 = this.entityConfigService.getRelatedCharacteristicTypes(this.selectedCharTypeId).then((result) => {
                _.forEach(result, (charType: Models.ICharacteristicType) => {
                    this.relatedCharTypes.push(charType);
                });
            });
            return this.$q.all([promise1, promise2]);
        }
    }

    // fired whenever template is changed
    RelatedTemplateChanged() {
        this.page = 1;				// reset page
        this.selectedRelatedChar = null;
        this.allRelatedChars = []; //clear selected chars
        this.allRelatedFilteredChars = [];
        this.notifyService.startProgress();
        this.allColumnCharsUpdated = false;
        this.allColumnRelatedCharsUpdated = true;
        var promise1 = this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.selectedRelatedCharTypeId, this.selectedRelatedTemplateId).then((result) => {
            for (var i = 0; i < result.length; i++) {
                var ct = result[i];
                var tagLabel = this.selectedRelatedCharTypeId + "_" + this.selectedRelatedTemplateId + "_" + ct.tagLabel;
                this.allRelatedChars[ct.characteristicID] = { tagName: tagLabel, label: ct.label };
                this.allRelatedFilteredChars[ct.characteristicID] = { tagName: tagLabel, label: ct.label };
            }
            if (this.selectedRelatedCharTypeId == 2) {
                this.entityConfigService.getTemplateParties(this.selectedCharTypeId, this.selectedTemplateId).then((result) => {
                    this.selectedRelatedTemplateParties = result;
                });
            }
            this.notifyService.endProgress();
        });
        return this.$q.all([promise1]);
    }

    UpdateCharacteristicsMultiSelectList(selectedChar) {
        //this.$log.info("UpdateCharacteristicMultiSelectList_1 called");
        this.page = 1;
        var sc = selectedChar[0];
        if (!_.any(this.reportingChars, rc => rc.characteristicID == sc.characteristicID)) {
            var newReportingChar: Models.IDynamicReportColumnChar = {
                characteristicID: sc.characteristicID,
                label: sc.label,
                tagName: sc.tagName
            };
            this.reportingChars.push(newReportingChar);
        }
    }

    AddCharacteristicToReport(selectedCharID) {
        this.page = 1;
        var selectedChar = this.allColumnFilteredChars[selectedCharID];
        if (!_.isUndefined(selectedChar)) {
            this.allColumnCharsUpdated = true;
            this.allColumnRelatedCharsUpdated = false;
            var newReportingChar: Models.IDynamicReportColumnChar = {
                characteristicID: selectedCharID[0],
                label: selectedChar.label,
                tagName: selectedChar.tagName
            };
            this.reportingChars.push(newReportingChar);
            delete this.allColumnFilteredChars[selectedCharID[0]];
        }
    }

    AddRelatedCharacteristicToReport(selectedRelatedCharID) {
        this.page = 1;
        var rsc = this.allRelatedChars[selectedRelatedCharID];
        if (!_.isUndefined(rsc)) {
            this.allColumnCharsUpdated = false;
            this.allColumnRelatedCharsUpdated = true;
            var newReportingChar: Models.IDynamicReportColumnChar = {
                characteristicID: selectedRelatedCharID[0],
                label: rsc.label,
                tagName: rsc.tagName
            };
            this.reportingChars.push(newReportingChar);
            delete this.allRelatedFilteredChars[selectedRelatedCharID[0]];
        }
    }

    RemoveCharacteristicFromReport(reportingChar: Models.IDynamicReportColumnChar, $event: ng.IAngularEvent) {
        //this.$log.info("RemoveCharacteristicFromReport_1 called");
        $event.preventDefault();
        this.page = 1;
        var removedAllColumnChar = this.allColumnChars[reportingChar.characteristicID];
        if (removedAllColumnChar != undefined && removedAllColumnChar.tagName == reportingChar.tagName) {
            this.removedAllColumnCharFromReportingChars = true;
        }
        else {
            this.removedAllColumnCharFromReportingChars = false;
        }

        _.remove(this.reportingChars, rc => rc.characteristicID == reportingChar.characteristicID && rc.tagName == reportingChar.tagName);

        if (this.removedAllColumnCharFromReportingChars) {
            this.allColumnFilteredChars[reportingChar.characteristicID] = removedAllColumnChar;
        }
        else {
            var removedAllRelatedColumnChar = this.allRelatedChars[reportingChar.characteristicID];
            if (removedAllRelatedColumnChar != undefined) {
                this.allRelatedFilteredChars[reportingChar.characteristicID] = removedAllRelatedColumnChar;
            }
        }

        if (this.reportingChars.length == 0) {
            this.itemRows = [];
            this.pageCount = 0;
        }
    }

    SaveReportParams() {
        //this.$log.info("SaveReportParams_1 called");
        var savedReportingChars = _.cloneDeep(this.reportingChars);

        var oneReport: Models.ISavedQueryReport = {
            reportName: this.reportName,
            charID: this.selectedCharTypeId,
            templateID: this.selectedTemplateId,
            relatedCharID: this.selectedRelatedCharTypeId,
            relatedTemplateID: this.selectedRelatedTemplateId,
            columns: savedReportingChars,
            relIndId: this.selectedRelatedTemplatePartyId
        };

        var storedReportParams = this.storage.get(this.savedDataExportReportKey) || [];
        storedReportParams.push(oneReport);
        this.storage.set(this.savedDataExportReportKey, storedReportParams);
        this.savedQueryReports = this.storage.get(this.savedDataExportReportKey) || [];
        this.reportName = "";
    }

    GetSavedReportParams() {
        //this.$log.info("GetSavedReportParams_1 called");
        var storedReportParams: Models.ISavedQueryReport[] = this.storage.get(this.savedDataExportReportKey) || [];
        this.savedQueryReports = storedReportParams;
        if (storedReportParams.length > 0) {
            _.forEach(storedReportParams, (report) => {
                this.savedReportNames.push(report.reportName);
            });
        }
    }

    ClearSavedReport(report: Models.ISavedQueryReport) {
        if (this.$window.confirm("Are you sure?")) {
            var storedReportParams: Models.ISavedQueryReport[] = this.storage.get(this.savedDataExportReportKey) || [];

            var index = -1;
            for (var i = 0; i < storedReportParams.length; i++) {
                if (storedReportParams[i].reportName == report.reportName) {
                    index = i;
                    break;
                }
            }

            if (index > -1) {
                storedReportParams.splice(index, 1);
                this.storage.set(this.savedDataExportReportKey, storedReportParams);
                this.GetSavedReportParams();
            }
        }
    }

    ClearAllSavedReports() {
        if (this.$window.confirm("Are you sure?")) {
            //this.$log.info("ClearAllSavedReports_1 called");
            this.storage.set(this.savedDataExportReportKey, null);
            this.GetSavedReportParams();
        }
    }

    LoadReport() {
        //this.$log.info("LoadReport_1 called");
        //this.$log.info("runnning report");
        this.selectedCharTypeId = this.selectedReport.charID;
        this.selectedRelatedTemplatePartyId = this.selectedReport.relIndId;
        this.CharTypeChanged()
            .then(() => {
                this.selectedTemplateId = this.selectedReport.templateID;
                this.TemplateChanged()
                    .then(() => {
                        if (this.selectedReport.relatedCharID > 0) {
                            this.selectedRelatedCharTypeId = this.selectedReport.relatedCharID;
                            this.RelatedCharTypeChanged().then(() => {
                                this.selectedRelatedTemplateId = this.selectedReport.relatedTemplateID;
                            });
                        }
                        this.reportingChars = this.selectedReport.columns;
                        this.showRelated = false;
                    });
            });
    }
}
